export default __webpack_public_path__ + "static/media/blur-investors.2c9ae49b.png";